// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PatreonTsx from "./Patreon.tsx";

function fetchApi(prim0, prim1) {
  return PatreonTsx.fetchApi(prim0, prim1);
}

var make = PatreonTsx.PatreonSvg;

var Svg = {
  make: make
};

export {
  fetchApi ,
  Svg ,
  
}
/* make Not a pure module */
